import { injectable, inject } from 'inversify'
import Debug from 'debug';
import { CommandQueue } from '../../shared/command-queue';
import * as Commands from './commands'
import { ResettableCancelToken, compoundCancelToken, CancelToken } from '@/app/shared/utils/cancel-token'

const debug = Debug('question-service');

export const QuestionServiceSymbol = Symbol.for('QuestionBankService2')

@injectable()
export class QuestionBankService2 {

  private localQueue: CommandQueue;
  private cancelToken: ResettableCancelToken

  constructor(
    @inject(Commands.LoadQuestionsCommandHandler)
    private loadQuestionsCommand: Commands.LoadQuestionsCommandHandler) {
    this.localQueue = new CommandQueue('question-service-local');
    this.cancelToken = new ResettableCancelToken()
  }

  public start(source: Commands.QuestionSource) {
    debug('starting QuestionService', source);

    this.localQueue.start();

    if (source) {
      const token = this.cancelToken.cancelAndReset()
      this.localQueue.queue('load-questions', (queueCancel) => this.load(source, token, queueCancel));
    }
  }

  public reset(source: Commands.QuestionSource) {
    debug('resetting QuestionService', source);

    if (source) {
      const token = this.cancelToken.cancelAndReset()
      this.localQueue.queue('reload-questions',
                            (queueCancel)  => this.load(source, token, queueCancel));
    }
  }

  private async load(source: Commands.QuestionSource, token: CancelToken, queueCancel: CancelToken) {
    await this.loadQuestionsCommand.execute(source, compoundCancelToken(token, queueCancel))
  }

  public async finish() {

    this.cancelToken.cancelAndReset()
    const stopPromises = [
      this.localQueue.stop(),
    ];

    await Promise.all(stopPromises);
  }
}
